import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { getSeriesColors } from '../../dashboardChartColors';

const CHART_HEIGHT = 280;

function DashboardPieChart({ series = [] }) {
    const labels = series.map((item) => item.label);
    const values = series.map((item) => item.value);
    const colors = getSeriesColors(series);

    const options = {
        chart: {
            type: 'pie',
            toolbar: { show: false },
            animations: { enabled: true, easing: 'easeinout', speed: 800 },
        },
        labels,
        colors,
        dataLabels: {
            enabled: true,
            formatter: (val, opts) => {
                const raw = opts.w.config.series[opts.seriesIndex];
                return `${Math.round(val)}%\n(${raw.toLocaleString()})`;
            },
            style: { fontSize: '11px', fontWeight: 600 },
            dropShadow: { enabled: false },
        },
        legend: {
            position: 'bottom',
            horizontalAlign: 'center',
            fontSize: '12px',
            markers: { width: 10, height: 10, radius: 4 },
        },
        stroke: { width: 3, colors: ['#fff'] },
        tooltip: {
            y: { formatter: (val) => val.toLocaleString() },
        },
    };

    return (
        <ReactApexChart
            options={options}
            series={values}
            type="pie"
            height={CHART_HEIGHT}
            width="100%"
        />
    );
}

export default DashboardPieChart;
